module.exports = __webpack_public_path__ + "img/c76.32d974d4.png";